import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParHonor from './par-honor';
import ParHonorDetail from './par-honor-detail';
import ParHonorUpdate from './par-honor-update';
import ParHonorDeleteDialog from './par-honor-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParHonorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParHonorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParHonorDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParHonor} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParHonorDeleteDialog} />
  </>
);

export default Routes;
